// AUTH0 Config credentials
export const AUTH_CONFIG = {
  domain: process.env.REACT_APP_AUTH_DOMAIN,
  clientID: process.env.REACT_APP_AUTH_CLIENT_ID,
  callbackUrl: process.env.REACT_APP_AUTH_CALLBACK_URL,
  audience: process.env.REACT_APP_AUTH_AUDIENCE
}